export default __webpack_public_path__ + "static/media/pengaturan_white.9bfc9e63.png";